export default __webpack_public_path__ + "fea43fa67b0cee18fa90786ded0cb682.png";